import React from 'react';
import { Info, AlertTriangle, CheckCircle, X } from 'lucide-react';

function Toast({ toast, onClose }) {
  if (!toast.show) return null;

  return (
    <div className="fixed top-10 right-10 z-[200] animate-in slide-in-from-right fade-in duration-500">
      <div className={`flex items-center gap-4 p-6 rounded-[30px] backdrop-blur-xl border shadow-2xl ${
        toast.type === 'error' ? 'bg-rose-500/10 border-rose-500/30 text-rose-400' :
        toast.type === 'info' ? 'bg-blue-500/10 border-blue-500/30 text-blue-400' :
        'bg-emerald-500/10 border-emerald-500/30 text-emerald-400'
      }`}>
        {toast.type === 'error' ? <AlertTriangle size={24}/> :
          toast.type === 'info' ? <Info size={24}/> :
          <CheckCircle size={24}/>}
        <div className="pr-4">
          <p className="text-[10px] font-black uppercase tracking-widest opacity-60 mb-1">{toast.type === 'error' ? 'Xatolik' : toast.type === 'info' ? 'Ma\'lumot' : 'Muvaffaqiyat'}</p>
          <p className="font-bold text-sm text-white">{toast.message}</p>
        </div>
        <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-xl transition"><X size={16}/></button>
      </div>
    </div>
  );
}

export default Toast;
